const menuItemGroupProps = {
  title: String
};

export { menuItemGroupProps };
//# sourceMappingURL=menu-item-group.mjs.map
